import { render, staticRenderFns } from "./admin-users.vue?vue&type=template&id=5889452e&scoped=true&"
import script from "./admin-users.vue?vue&type=script&lang=js&"
export * from "./admin-users.vue?vue&type=script&lang=js&"
import style0 from "./admin-users.vue?vue&type=style&index=0&id=5889452e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5889452e",
  null
  
)

export default component.exports